import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "container",
    "referral",
    "mainImage",
    "vaccinated",
    "appointment",
    "invoice",
    "secondDose",
    "records",
    "background",
  ]

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this))
    this.observer.observe(this.containerTarget)
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      this.runAnimation(entry.isIntersecting)
    })
  }

  runAnimation(visible) {
    this.mainImageTargets.forEach(target => this.animateTarget(target, !visible))
    this.backgroundTargets.forEach(target => this.animateTarget(target, visible))
    this.appointmentTargets.forEach(target => this.animateTarget(target, visible))
    this.invoiceTargets.forEach(target => this.animateTarget(target, visible))
    this.referralTargets.forEach(target => this.animateTarget(target, visible))
    this.secondDoseTargets.forEach(target => this.animateTarget(target, visible))
    this.recordsTargets.forEach(target => this.animateTarget(target, visible))
    this.vaccinatedTargets.forEach(target => this.animateTarget(target, visible))
  }

  animateTarget(target, visible) {
    const distances = {
      mainImage: ["scale-50"],
      background: [],
      appointment: ["-translate-y-[45%]", "translate-x-[85%]"],
      invoice: ["translate-y-[180%]", "translate-x-[60%]"],
      referral: ["translate-y-[260%]"],
      secondDose: ["translate-y-[83%]", "-translate-x-[70%]"],
      records: ["-translate-y-[150%]", "-translate-x-[70%]"],
      vaccinated: ["-translate-y-[200%]"],
    }

    const targetClasses = {
      mainImage: this.mainImageTargets,
      background: this.backgroundTargets,
      appointment: this.appointmentTargets,
      invoice: this.invoiceTargets,
      referral: this.referralTargets,
      secondDose: this.secondDoseTargets,
      records: this.recordsTargets,
      vaccinated: this.vaccinatedTargets,
    }

    const targetName = Object.keys(targetClasses).find(key =>
      targetClasses[key].includes(target),
    )

    const styles = distances[targetName] || []

    if (visible) {
      target.classList.add("scale-100", ...styles)
    } else {
      target.classList.remove("scale-100", ...styles)
    }
  }
}
